import React, { useEffect } from 'react';

import Rive from '@rive-app/react-canvas';
import usePathname from 'app-migration/hooks/usePathname';
import useStores from 'app-migration/store';

import Text from 'DesignSystem2/Text';
import { Palette } from 'DesignSystem2/Theme';

const TransfersLoading = ({ amount }: { amount?: number }) => {
    const { traderStore } = useStores();
    const userStore = traderStore.user;

    const pathname = usePathname();
    const isSignUp = pathname.includes('/sign-up');

    useEffect(() => {
        if (isSignUp) {
            userStore.metrics.recordSignUpMetric({
                step: 'depositLoading',
            });
        }
    }, [isSignUp]);

    return (
        <div className={'flex flex-col justify-center mb-3 mt-3'}>
            <Rive
                src={'/animations/animations.riv'}
                artboard={'transfer'}
                animations={['loading']}
                className={'w-full h-[200px] mb-4'}
            />
            <div className={'px-4 flex flex-col items-center'}>
                <Text.Heading.x15 color={Palette.Text.x10} className={'mb-1 text-center'}>
                    {amount ? `Processing your transfer of $${amount}...` : 'Processing your transfer...'}
                </Text.Heading.x15>
            </div>
            <Text.Body.x30 color={Palette.Text.x20} className={'text-center'}>
                {'Please stay on this screen. It may take up to 30 seconds.'}
            </Text.Body.x30>
        </div>
    );
};

export default TransfersLoading;
